<div [class]="wrapperClassContent">
    <div class="star-rating">
        <ng-container *ngFor="let item of scoreItems; let i = index">
            <input type="radio" name="stars" id="star-{{5-i}}" value="{{5-i}}" />
            <label for="star-{{5-i}}"></label>
        </ng-container>
    </div>
</div>
